<template>
  <div class="main-view">
    <div class="section shadow filter__wrap">
      <el-form ref="elFormDom" inline :model="table.params" :size="subUnitSize">
        <el-row>
          <el-col :span="24">
            <el-form-item label="采购月份" prop="year">
              <el-date-picker
                v-model="table.params.year"
                type="year"
                placeholder="选择月"
                :clearable="false"
                value-format="yyyy"
                format="yyyy"
                @change="changeYear"
                class="yearwrap"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="" prop="quarter">
              <span
                :class="
                  table.params.month_str == v ? 'monthV acColor' : 'monthV'
                "
                v-for="(v, i) in this.monthObj"
                :key="v"
                @click="selMonth(v, i)"
              >
                <span>{{ v }}月</span>
              </span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="商品名称" prop="goods_name">
          <el-input
            size="mini"
            v-model.trim="table.params.goods_name"
            placeholder="请输入商品名称"
            clearable
            @keydown.enter.native="onSearch"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="下单分类" prop="cate_id">
          <el-select v-model="table.params.cate_id" filterable placeholder="请选择" @focus="getOrderCateSel" clearable @change="onSearch">
            <el-option
              v-for="item in orderCateArr"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="食堂名称" prop="address_id">
          <el-select v-model="table.params.address_id" filterable placeholder="请输入" clearable @focus="getStoreSel" @change="onSearch">
            <el-option v-for="item in storeArr" :key="item.id" :label="item.name" :value="item.id">
              <span style="float: left">{{ item.name }}</span>
              <span style="float: right; color: #8492a6; font-size: 13px">({{ item.merchant_name }})</span>
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="供应商名称" prop="supplier_id">
          <el-select
            v-model="table.params.supplier_id"
            filterable
            id="bind_id"
            clearable
            placeholder="请输入"
            @focus="getSupplierSel"
            @change="onSearch"
          >
            <el-option
              v-for="item in supplierArr"
              :label="item.name"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="采购日期" prop="date">
          <el-date-picker
            v-model="table.params.date"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="onSearch"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="类别" prop="type">
          <el-radio-group v-model="table.params.type" @input="onSearch">
            <el-radio :label="1">蔬菜</el-radio>
            <el-radio :label="2">其他</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSearch"
            >搜索</el-button
          >
          <el-button icon="el-icon-refresh-right" @click="reset2"
            >重置</el-button
          >
        </el-form-item>
      </el-form>
      <div class="btnAdd">
        <el-button
          v-if="is_sys"
          :size="subUnitSize"
          type="primary"
          plain
          @click="handleExport"
          icon="el-icon-download"
          >导出</el-button
        >

        <el-tooltip
          class="item"
          effect="dark"
          content="省纪委的采购价除蔬菜以外，其他类别的商品以导入价格为准"
          placement="right"
        >
          <el-button
            v-if="is_sys"
            type="primary"
            plain
            :size="subUnitSize"
            icon="el-icon-warning-outline"
            @click="dialogVisiblePrice = true"
            >导入</el-button
          >
        </el-tooltip>
      </div>
    </div>

    <VTable
      has-pagionation
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :page="table.params.page"
      :pageSize="table.params.count"
      :total="table.total"
      :tree-props="{ children: 'children', hasChildren: 'has_child' }"
      :hasPagionation="true"
      :showSelect="true"
      :showIndex="true"
      :tableRowClassName="tableRowClassNameFun"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectionChange="handleSelectionChange"
    >
      <template v-slot:goods_name="{ row }">
        <div style="display: flex; align-items: center">
          <div style="width: 40px; height: 40px">
            <el-image
              v-if="!!row.image"
              style="width: 40px; height: 40px"
              :src="row.image"
              fit="cover"
              :preview-src-list="[row.image]"
            ></el-image>
            <el-image
              v-else
              style="width: 40px; height: 30px"
              :src="require('@/assets/img/logo-icon.jpeg')"
              fit="cover"
              :preview-src-list="[require('@/assets/img/logo-icon.jpeg')]"
            ></el-image>
          </div>
          <span style="margin-left: 10px; min-width: 120px">{{
            row.goods_name
          }}</span>
        </div>
      </template>
      <template v-slot:purchase_price="{ row }">
        <span>￥{{ row.purchase_price }}</span>
        <!-- <span v-if="row.rate >= 5" style="margin-left:10px;font-size:12px;">(较上次<i class="el-icon-top"></i>{{row.rate}}%)</span>
        <span v-if="row.rate <= -5" style="margin-left:10px;font-size:12px;">(较上次<i class="el-icon-bottom"></i>{{Math.abs(row.rate)}}%)</span> -->
      </template>
      <template v-slot:action="{ row }">
        <el-button type="text" @click="showCharts(row)">查看趋势</el-button>
      </template>
    </VTable>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="500px"
      :before-close="handleClose"
      center
    >
      <el-alert
        v-if="this.multipleSelection.length == 0"
        title="提示：您未选择商品，系统将会导出列表全部信息"
        type="warning"
        :closable="false"
        style="margin-bottom: 10px"
      >
      </el-alert>
      <el-form :model="form.data" :rules="form.rules" v-if="dialogVisible">
        <el-form-item label="采购日期" prop="date">
          <el-date-picker
            v-model="form.data.date"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            :picker-options="selpickerOptions"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确定导出</el-button>
      </span>
    </el-dialog>

    <!-- 趋势 -->
    <Charts ref="charts"></Charts>
    <!-- 导入 -->
    <el-dialog
      title="导入采购价"
      :visible.sync="dialogVisiblePrice"
      width="400px"
      @close="handleClosePrice"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      center
    >
      <el-form
        class="staff-from"
        label-width="100px"
        :size="subUnitSize"
        max-height="600px"
      >
        <el-form-item label="上传采购单">
          <el-upload
            class="upload-demo"
            action=""
            :on-change="handleChange"
            :on-remove="handleRemovePrice"
            :file-list="formPrice.file"
            :auto-upload="false"
          >
            <el-button size="small" type="primary">上传文件</el-button>
            <el-button size="small" type="text" @click="dowfile_2"
              >下载样表</el-button
            >
          </el-upload>
        </el-form-item>
      </el-form>
      <template #footer>
        <el-row type="flex" justify="center">
          <el-button type="primary" @click="importPrice">确定</el-button>
        </el-row>
      </template>
    </el-dialog>
    <!-- 导入异常弹窗 -->
    <el-dialog
      title="导入采购价反馈信息"
      :visible.sync="errorDialogVisible"
      width="500px"
      center
      :before-close="errorClose"
    >
      <div style="font-weight: bold">
        导入成功：{{ templateDialog.result }} 条
      </div>
      <div v-if="templateDialog.errors.length > 0" class="errorBox">
        <p v-for="(item, index) in templateDialog.errors" :key="index">
          {{ index + 1 }}、{{ item }}
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="errorClose">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Charts from "./components/mycharts.vue";
import VTable from "@/components/VTable";
import { mixinTable } from "@/mixins/table.js";
import { getStorage } from "@/storage";

export default {
  name: "purchasepriceIndex",
  components: {
    Charts,
    VTable,
  },
  mixins: [mixinTable],
  data() {
    return {
      merchant_id: getStorage("merchant_id"),
      login_account: getStorage("account"),
      is_sys: getStorage("is_sys"),
      subUnitSize: this.$store.state.subUnitSize, // 获取组件 size属性
      field: [
        { name: "goods_name", label: "商品名称", hidden: false },
        { name: "unit_name", label: "单位", width: "100", hidden: false },
        { name: "name", label: "规格", width: "120", hidden: false },
        {
          name: "purchase_price",
          label: "最新采购价",
          width: "180",
          hidden: false,
        },
        { name: "supplier_name", label: "所属供应商", hidden: false },
        { name: "date", label: "采购日期", width: "120", hidden: false },
        // {
        //   name: "delivery_time",
        //   label: "更新时间",
        //   width: "160",
        //   hidden: false,
        // },
        {
          name: "action",
          label: "操作",
          width: "100",
          fixed: "right",
          hidden: false,
        },
      ],
      multipleSelection: [],
      table: {
        loading: false,
        params: {
          year: "", //年份
          month: "", // 当前月
          month_str: "",
          goods_name: "",
          address_id: "", // 食堂id
          supplier_id: "", // 供应商ID
          cate_id: "", //下单分类ID
          merchant_id: getStorage("merchant_id"),
          type: 1, // 类别
          page: 1,
          count: 20,
        },
        data: [],
        total: 0,
      },
      monthObj: [
        "01",
        "02",
        "03",
        "04",
        "05",
        "06",
        "07",
        "08",
        "09",
        "10",
        "11",
        "12",
      ],
      orderCateArr: [], // 下单分类
      supplierArr: [], // 供应商
      storeArr: [], // 食堂
      dialogVisible: false,
      form: {
        loading: false,
        data: {
          date: [],
        },
        rules: {
          date: [
            { required: true, message: "请选择采购日期", trigger: "change" },
          ],
        },
      },
      selpickerOptions: {
        onPick: ({ maxDate, minDate }) => {
          this.isRestart = false;
          this.pickerMinDate = minDate.getTime();
          if (maxDate) {
            this.pickerMinDate = "";
          }
        },
        disabledDate: (time) => {
          //查询时间跨度为31天
          if (this.curveTime && this.isRestart) {
            return; // 存在选中的日期且没有重新选择日期 不做禁用处理
          }
          if (this.pickerMinDate !== "") {
            const one = 31 * 24 * 3600 * 1000;
            const minTime = this.pickerMinDate - one;
            const maxTime = this.pickerMinDate + one;
            return time.getTime() < minTime || time.getTime() > maxTime;
          }
        },
      },
      dialogVisiblePrice: false,
      formPrice: {
        file: [],
      },
      file_2: "",
      errorDialogVisible: false,
      templateDialog: {
        result: 0,
        errors: [],
      },
    };
  },
  created() {
    this.table.params.year = new Date().getFullYear().toString(); // 默认当前年份
    this.table.params.month_str = this.$moment(new Date()).format("MM"); // 默认当前年份
    this.table.params.month =
      new Date().getFullYear().toString() +
      "-" +
      this.$moment(new Date()).format("MM"); // 默认当前月份
    this.getTable();
  },
  methods: {
    handleClosePrice() {
      this.formPrice = {
        file: [],
      };
    },
    handleChange(file) {
      this.formPrice.file = [file];
    },
    handleRemovePrice() {
      this.formPrice.file = [];
    },
    dowfile_2() {
      window.open(this.file_2);
    },
    importPrice() {
      if (!this.formPrice.file || this.formPrice.file.length == 0) {
        this.$message.error("请上传文件");
        return;
      }
      this.dialogVisiblePrice = false;
      let formData = new FormData();
      formData.append("file", this.formPrice.file[0].raw);
      this.$http.post("/admin/veggie/import", formData).then((res) => {
        if (res.code === 1) {
          if (res.data.errors.length == 0) {
            this.$message.success("导入成功");

            this.formPrice = {
              date: [],
              is_change: "",
              file: [],
            };
          } else {
            this.errorDialogVisible = true;
            this.templateDialog.errors = res.data.errors;
            this.templateDialog.result = res.data.success_count;
          }
          this.getTable();
        }
      });
    },
    errorClose() {
      this.errorDialogVisible = false;
    },
    // 选择年份
    changeYear(value) {
      this.table.params.month = value + "-" + this.table.params.month_str;
      this.getTable();
    },
    // 选月份
    selMonth(v, i) {
      this.table.params.month_str = v;
      this.table.params.month = this.table.params.year + "-" + v;
      this.getTable();
    },
    getTable() {
      this.table.loading = true;
      this.$http
        .get("/admin/veggie/list", { params: this.table.params })
        .then((res) => {
          if (res.code === 1) {
            this.table.loading = false;
            // 数据清洗，确保字段类型正确
            this.table.data = Array.isArray(res.data.list) ? res.data.list : []
            this.table.total = res.data.total;
            this.file_2 = res.data.file;
          }
        });
    },
    // 趋势
    showCharts(row) {
      let dom = this.$refs.charts;
      dom.toggle(true);
      dom.getDetail(row);
      dom = null;
    },
    handleExport() {
      this.$nextTick(() => {
        const end = new Date();
        const start = new Date();
        this.form.data.date[0] = this.$moment(start).format("YYYY-MM-DD");
        this.form.data.date[1] = this.$moment(end).format("YYYY-MM-DD");
      });
      this.dialogVisible = true;
    },
    // 导出
    confirm() {
      let obj = "";
      if (this.multipleSelection.length > 0) {
        obj = {
          start: this.form.data.date[0],
          end: this.form.data.date[1],
          ids: this.multipleSelection.map((v) => v.spec_id).join("|"),
          goods_name: this.table.params.goods_name,
          address_id: this.table.params.address_id, // 食堂id
          supplier_id: this.table.params.supplier_id, // 供应商ID
          cate_id: this.table.params.cate_id, //下单分类ID
        };
      } else {
        obj = {
          start: this.form.data.date[0],
          end: this.form.data.date[1],
          goods_name: this.table.params.goods_name,
          address_id: this.table.params.address_id, // 食堂id
          supplier_id: this.table.params.supplier_id, // 供应商ID
          cate_id: this.table.params.cate_id, //下单分类ID
        };
      }
      let str = "";

      Object.keys(obj).forEach((item) => {
        str += `&${item}=${obj[item]}`;
      });
      let url = "/admin/veggie/export";
      console.log(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
      window.open(
        `${process.env.VUE_APP_BASE_API}${url}?token=${this.token}${str}`
      );
      this.handleClose();
    },
    handleClose() {
      this.dialogVisible = false;
      this.form.data.date = [];
    },
    tableRowClassNameFun({ row, rowIndex }) {
      if (row.rate >= 5) {
        return "warning-row";
      } else if (row.rate <= -5) {
        return "success-row";
      }
      {
        return "";
      }
    },
  },
};
</script>
<style scoped>
.monthV {
  margin-left: 10px;
  cursor: pointer;
  font-weight: bold;
  color: #595959;
  border: solid 1px #eee;
  padding: 3px 10px;
  border-radius: 5px;
}
.acColor {
  color: #409eff;
  border: solid 1px #409eff;
}
.yearwrap {
  width: 100px;
}
::v-deep .yearwrap .el-input__inner {
  width: 100px !important;
}
</style>